import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContractEONType,
  CurrencyField,
  DataTable,
  DateTimeField,
  Field,
  PaidBadge,
} from '../../commons/DataTable';
import TotalTr from './TotalTr';
import ModalAddDocument from './ModalAddDocument';
import ManageDocument from './ManageDocument';
import ModalAddPaymentPolis from './ModalAddPaymentPolis';
import ModalAddPayment from './ModalAddPayment';
import ExtraInvoiceField from '../../commons/DataTable/ExtraInvoiceField';
import ResponsibleField from '../../commons/DataTable/ResponsibleField';
import { ENERGY_USERS_ADMIN } from '../../App';
import FieldIafNumber from '../../commons/DataTable/FieldIafNumber';

function RecurringFeesTable({
  profile,
  profileType,
  data,
  total,
  offset,
  limit,
  onFilter,
  handleFileListView,
  handleDelete,
  onStatusChanged,
  onAddPayment,
}) {
  const [t] = useTranslation('CONTRACTS');

  const getTotals = (data) => {
    const extraShareTotals = data.reduce(
      (prev, cur) => prev + cur.extraShare,
      0
    );
    const adminShareTotals = data.reduce(
      (prev, cur) => prev + cur.adminShare,
      0
    );
    const contractValueTotals = data.reduce(
      (prev, cur) => prev + cur.contract_value,
      0
    );

    return {
      extraShareTotals,
      adminShareTotals,
      contractValueTotals,
    };
  };

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
      bottomRow={
        <TotalTr
          profileType={profileType}
          totals={getTotals(data)}
          profile={profile}
        />
      }
    >
      <Field title="POD/PDR" source="pod_pdr" />
      <ResponsibleField
        title="Responsabile"
        source="admin.name"
        visible={profileType === 'EON_ENERGY'}
      />
      <Field
        title="Partita iva responsabile"
        source="condo_admin_cf"
        visible={profileType === 'EON_ENERGY'}
      />
      <Field
        title="Fornitore"
        source="supplier.businessName"
        visible={ENERGY_USERS_ADMIN.includes(profileType)}
      />
      <Field
        title="P.Iva/Codice fiscale fornitore"
        source="supplier.fiscalCode"
        visible={ENERGY_USERS_ADMIN.includes(profileType)}
      />
      <Field title="Nome cliente" source="condo_name" className="text-left" />
      <Field title="Partita IVA cliente" source="condo_vat_cf" />
      <DateTimeField
        title="Data creazione"
        source="contract_signing_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data attivazione"
        source="activation_start_date"
        format="DD/MM/YYYY"
      />
      <Field title="Consumo da contratto" source="contractual_consumption" />
      <Field title="Consumo attuale" source="actual_consumption" />
      <Field
        title="Consumo effettivo"
        source="anniversary_consumption"
        visible={
          profile.polis === true || ENERGY_USERS_ADMIN.includes(profileType)
        }
      />
      <ContractEONType title="Nome prodotto" source="product_name" />
      <Field
        title="Mensilità ricorrenze"
        source="recurringMonthlyPayment"
        visible={
          profile.polis === true || ENERGY_USERS_ADMIN.includes(profileType)
        }
      />
      <Field title="Causale" source="denomination" />
      <DateTimeField
        title="Data Scadenza"
        source="contract_end_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data COMPENSO"
        source="dateFee"
        format="DD/MM/YYYY"
      />
      <CurrencyField
        title="Profitto Extra Fisso"
        source="extraShareFixed"
        visible={profile.polis === true}
      />
      <CurrencyField
        title="Profitto Responsabile Fisso"
        source="adminShareFixed"
        visible={profile.polis === true}
      />
      <CurrencyField
        title="Profitto Extra Variabile"
        source="extraShareDynamic"
        visible={profile.polis === true}
      />
      <CurrencyField
        title="Profitto Responsabile Variabile"
        source="adminShareDynamic"
        visible={profile.polis === true}
      />
      <CurrencyField
        title="Profitto Extra"
        source="extraShare"
        visible={profile.polis === true}
      />
      <CurrencyField
        title="Profitto Responsabile"
        source="adminShare"
        visible={
          profile.polis === true || ENERGY_USERS_ADMIN.includes(profileType)
        }
      />
      <PaidBadge title="Incassato" source="paid" />
      <ModalAddPaymentPolis
        title="Aggiungi incasso"
        onAddPayment={onAddPayment}
        visible={profile.polis === true}
      />
      <ModalAddPayment
        title="Aggiungi incasso"
        onAddPayment={onAddPayment}
        visible={profile.polis !== true && profileType === 'EON_ENERGY'}
      />
      <ExtraInvoiceField title="Fattura extra" source="pinvInvoice[0]" />
      <FieldIafNumber
        title="Numero IAF"
        className="txt-table-right"
        source="iaf.number"
        visible={ENERGY_USERS_ADMIN.includes(profileType)}
      />
      <ModalAddDocument
        title="Aggiungi documento"
        onStatusChanged={onStatusChanged}
        visible={profile.polis === true}
      />
      <ManageDocument
        title="Gestisci documento"
        handleFileListView={handleFileListView}
        handleDelete={handleDelete}
        visible={profile.polis === true}
      />
    </DataTable>
  );
}

export default RecurringFeesTable;
